module.exports = __webpack_public_path__ + "static/media/13.b9ed5767.jpg";